import React from 'react';
import styled from 'styled-components';

import Banner from '@joinforma/ui/components/Banner';
import { BannerVariant } from '@joinforma/ui/constants/properties';
import Body2 from '@joinforma/ui/components/Body2';
import { PretaxAccountV2Type } from 'constants/accounts';

const ConsolidateMessage = styled(Body2)`
  font-weight: 500;
`;

const displayMessage = (accountType: string) => {
  if (
    accountType === PretaxAccountV2Type.PARKING ||
    accountType === PretaxAccountV2Type.TRANSIT
  ) {
    return "We're experiencing interruptions with our Commuter benefits that might cause card transactions to be declined. Our teams are working diligently to fix this as soon as possible.";
  }
  if (
    accountType === PretaxAccountV2Type.FSA ||
    accountType === PretaxAccountV2Type.LPFSA ||
    accountType === PretaxAccountV2Type.DCFSA
  ) {
    return "We're experiencing interruptions with our FSA cards that might cause transactions to be declined. Our teams are working diligently to fix this as soon as possible.";
  }
  return "We're experiencing interruptions that might cause FSA and Commuter transactions to be declined. Our teams are working diligently to fix this as soon as possible.";
};

const DeclinedTransctionsBanner = ({
  accountType = 'settings',
}: {
  accountType?: string;
}) => (
  <Banner
    variant={BannerVariant.WARNING}
    content={
      <>
        <ConsolidateMessage>
          {displayMessage(accountType.toLowerCase())}
        </ConsolidateMessage>
      </>
    }
  />
);

export default DeclinedTransctionsBanner;
